// Küçük className birleştirici (clsx/tailwind-merge'e gerek yok).
// Falsy değerleri atar, iç içe dizileri düzleştirir.
export function cn(...args) {
  return args
    .flat(Infinity)
    .filter(Boolean)
    .join(' ');
}

export default cn;
